import Vue from 'vue'
import { ISocketPayload } from '@/system/socket/store'
import { ITransformPayload } from '@/features/matchFields/store'
import {
  FETCH_PROJECT_LIST_ACTION,
  FETCH_RESERVATION_TYPES_ACTION,
  TRANSFORM_DATA_ACTION,
  FETCH_CUSTOMERS_ACTION
} from '@/system/store/action-types'
const {
  VUE_APP_WEBSOCKET_URL
} = process.env

export default class WebSocketService extends Vue {
  private mainWSURL: string

  constructor () {
    super()
    this.mainWSURL = VUE_APP_WEBSOCKET_URL
  }

  async connect (params: { token: string, customer: string }): Promise<void> {
    const { token, customer } = params
    const wsUrl = `${this.mainWSURL}?token=${token}&customer=${customer}`
    await this.$connect(wsUrl)
  }

  fetchCustomers (): void {
    this.$socket.sendObj({ action: FETCH_CUSTOMERS_ACTION })
  }

  fetchReservationTypes (payload: ISocketPayload = {}): void {
    this.$socket.sendObj({ action: FETCH_RESERVATION_TYPES_ACTION, ...payload })
  }

  transformData (payload: ISocketPayload<ITransformPayload> = {}): void {
    this.$socket.sendObj({ action: TRANSFORM_DATA_ACTION, ...payload })
  }

  fetchProjectList (payload: ISocketPayload = {}): void {
    this.$socket.sendObj({ action: FETCH_PROJECT_LIST_ACTION, ...payload })
  }
}
